export enum SettingsMode {
  GLOBAL = 'SWAP_LIQUIDITY',
  SWAP_LIQUIDITY = 'SWAP_LIQUIDITY',
}
// change this to the correct path 'GLOBAL'